import PropTypes from "prop-types";
import React, { Fragment } from "react";

import FormDropdownMenu from "../../components/form/FormDropdownMenu";

class FormDropdownMenuTrigger extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: false
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
  }

  toggleFormList(menuOpen) {
    if (!menuOpen) {
      this.setState({ addedRelationshipId: null, addedRelationshipIsInverse: false });
    }
  }

  toggleFormDropdown(menuOpen) {
    if (!menuOpen) {
      this.setState({ showMoreRelationships: false });
    }
  }

  toggleMenu() {
    this.setState({
      showMenu: !this.state.showMenu
    });
  }

  onOptionClick(val) {
    this.props.onOptionClick(val);
    if (!this.props.remainOpenAfterClick) {
      this.toggleMenu();
    }
  }

  render() {
    let dropdownProps = Object.assign({}, this.props);
    delete dropdownProps.children;
    delete dropdownProps.closeOnClick;

    const triggerElement = React.cloneElement(React.Children.only(this.props.children), {
      onClick: this.toggleMenu
    });

    return (
      <Fragment>
        {triggerElement}
        <FormDropdownMenu
          {...dropdownProps}
          showMenu={this.state.showMenu}
          onOptionClick={this.onOptionClick}
          onToggleMenu={this.toggleMenu}
        />
      </Fragment>
    );
  }
}

// Can take any other props that should be passed through to FormDropdownMenu
// and they will be passed through!
FormDropdownMenuTrigger.propTypes = {
  children: PropTypes.element.isRequired,
  remainOpenAfterClick: PropTypes.bool,
  onOptionClick: PropTypes.func.isRequired
};

export default FormDropdownMenuTrigger;
